const root = 'ProductSlate-shippingSection'
const shippingInfo = `${root}-shippingInfo`

export const TestId = {
  countrySelect: `${root}-countrySelect`,
  shippingInfo,
  shippingPrice: `${shippingInfo}-shippingPrice`,
}
